import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadCrumbsService {
  private breadcrumbs = new BehaviorSubject<any>([]);

  breadcrumbs$ = this.breadcrumbs.asObservable();

  setBreadCrumbs(val: any[]) {
    this.breadcrumbs.next(val);
  }
}
